import * as React from 'react';

function IconQuestionMark(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>): React.JSX.Element {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="inline-flex h-[1.715em] w-[1.715em] flex-shrink-0"
            data-taco="icon"
            data-icon-name="question-mark"
            focusable="false"
            role="img"
            ref={svgRef}
            {...props}>
            <path
                d="M5.36889 7.72819C5.36298 7.99576 5.58532 8.20801 5.85296 8.20801H9.00016C9.27427 8.20801 9.49224 7.98585 9.53714 7.71545C9.72128 6.60663 10.5019 5.81494 11.8031 5.81494C12.9642 5.81494 14.0545 6.43799 14.0545 7.86816C14.0545 9.11426 13.1908 9.70898 11.8597 10.5728C10.1463 11.6631 9.22593 13.1074 9.43833 15.2881L9.44586 15.4612C9.45749 15.7286 9.67769 15.9395 9.94539 15.9395H12.9457C13.2218 15.9395 13.4457 15.7156 13.4457 15.4395V15.2598C13.4457 13.7446 14.1112 13.3057 15.7679 12.187C17.1415 11.2524 18.6283 10.1621 18.6283 7.6416C18.6283 4.07324 15.6263 2.31738 12.0721 2.31738C8.71074 2.31738 5.454 3.87378 5.36889 7.72819ZM8.80113 19.9751C8.80113 21.3628 9.89146 22.2974 11.5765 22.2974C13.3182 22.2974 14.3944 21.3628 14.3944 19.9751C14.3944 18.5591 13.3041 17.6245 11.5765 17.6245C9.8773 17.6245 8.80113 18.5591 8.80113 19.9751Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
}
export default React.forwardRef(IconQuestionMark);
